import type { paths } from '@/services/api-allo/api-allo-v1';
import { $apiAllo } from '@/services/api-allo/client';

type AttributePath = Extract<keyof paths, `/v1/${string}/attribute`>;
export type TableDefinitionEntity = AttributePath extends `/v1/${infer Entity}/attribute`
  ? Entity
  : never;

export function useTableDefinition(entity: TableDefinitionEntity) {
  return $apiAllo.useQuery('get', `/v1/${entity}/attribute`, undefined, {
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
